export default __webpack_public_path__ + "static/media/user.bbaac574.svg";